// Copyright (c) 2016 Deere & Company

import ProductDetails, {getDefaultState} from '../state';
import Component from '@deere/cps-it.warranty-model-factory/lib/component';
import ProductOption from '@deere/cps-it.warranty-model-factory/lib/option';
import actions from '../../actions-list';
import {getDefaultState as getBaseMachineImplementsDefaultState} from '@deere/cps-it.warranty-model-factory/lib/implement-serial-number';

const decreaseBusyCounter = state =>
    ProductDetails.update(state, {
        busyCounter: {
            $set: state.busyCounter > 0 ? state.busyCounter - 1 : 0
        }
    });

const increaseBusyCounter = state =>
    ProductDetails.update(state, {
        busyCounter: {
            $set: state.busyCounter + 1
        }
    });

const updateProductDetails = (state, action) =>
    ProductDetails.update(state, {
        [action.property]: {
            $set: action.payload
        }
    });

const setCustomer = (state, action) =>
    ProductDetails.update(state, {
        [action.property]: {
            $merge: {
                ...action.payload
            }
        }
    });

const resetComponentToAdd = (state, action) =>
    ProductDetails.update(state, {
        componentToAdd: {
            $set: new Component({
                ...getDefaultState().componentToAdd,
                pin: action.pin
            })
        }
    });

const resetOptionToAdd = (state, action) =>
    ProductDetails.update(state, {
        optionToAdd: {
            $set: new ProductOption({
                ...getDefaultState().optionToAdd,
                pin: action.pin
            })
        }
    });

const updateIncentiveDetails = (state, action) =>
    ProductDetails.update(state, {
        incentivePrograms: {
            $set: action.payload
        }
    });

const toggleAccordions = (state, action) =>
    ProductDetails.update(state, {
        accordions: {
            $merge: {
                amountOfUseIsExpanded: action.isExpanded,
                baseMachineComponentsIsExpanded: action.isExpanded,
                componentsIsExpanded: action.isExpanded,
                externalNotesIsExpanded: action.isExpanded,
                incentiveProgransIsExpanded: action.isExpanded,
                internalNotesIsExpanded: action.isExpanded,
                maintenancePlanIsExpanded: action.isExpanded,
                optionCodesIsExpanded: action.isExpanded,
                pastClaimsIsExpanded: action.isExpanded,
                pipHistoryIsExpanded: action.isExpanded,
                registrationHistoryIsExpanded: action.isExpanded
            }
        }
    });

const updateAmountOfUseModalVisibility = (state, action) =>
    ProductDetails.update(state, {
        isAmountOfUseModalOpen: {
            $set: action.isVisible
        }
    });

const updateEditAmountOfUseModalVisibility = (state, action) =>
        ProductDetails.update(state, {
            isAmountOfUseEditModalOpen: {
                $set: action.isVisible
            }
        });

const toggleAccordion = (state, action) =>
    ProductDetails.update(state, {
        accordions: {
            [action.accordionName]: {
                $set: action.isExpanded
            }
        }
    });

const updateClaimTypes = (state, action) =>
    ProductDetails.update(state, {
        createClaimModal: {
            claimTypes: {
                $set: action.claimTypes
            }
        }
    });

const updateComponentCodes = (state, action) =>
    ProductDetails.update(state, {
        componentCodes: {
            $set: action.componentCodes
        }
    });

const updateComponentToAdd = (state, action) =>
    ProductDetails.update(state, {
        componentToAdd: {
            [action.property]: {
                $set: action.value
            }
        }
    });

const updateCreateClaimModalVisibility = (state, action) =>
    ProductDetails.update(state, {
        createClaimModal: {
            isModalOpen: {
                $set: action.isVisible
            }
        }
    });

const updateOptionToAdd = (state, action) =>
    ProductDetails.update(state, {
        optionToAdd: {
            [action.property]: {
                $set: action.value
            }
        }
    });

const updatePurchaseOrder = (state, action) =>
    ProductDetails.update(state, {
        baseMachineComponents: {
            purchaseOrder: {
                $set: action.value
            }
        }
    });

const updateTempPurchaseOrder = (state, action) =>
    ProductDetails.update(state, {
        baseMachinePurchaseOrder: {
            $set: action.purchaseOrder
        }
    });

const updateShowAddComponentRow = (state, action) =>
    ProductDetails.update(state, {
        showAddComponentRow: {
            $set: action.isVisible
        }
    });

const updateProductDetailsStatusChangeModal = (state, action) =>
    ProductDetails.update(state, {
        productDetailsStatusChangeModal: {
            [action.name]: {
                $set: action.value
            }
        }
    });

const addComponents = state =>
    ProductDetails.update(state, {
        baseMachineComponents: {
            components: {
                $push: [getBaseMachineImplementsDefaultState()]
            }
        }
    });

const deleteComponents = (state, action) =>
    ProductDetails.update(state, {
        baseMachineComponents: {
            components: {
                $splice: [
                    [
                        action.index,
                        1
                    ]
                ]
            }
        }
    });

const updateBaseMachineComponents = (state, action) =>
    ProductDetails.update(state, {
        baseMachineComponents: {
            components: {
                [action.index]: {
                    serialNumber: {
                        $set: action.value
                    }
                }
            }
        }
    });

const updateFile = (state, action) =>
    ProductDetails.update(state, {
        baseMachineComponents: {
            file: {
                $set: action.file
            }
        }
    });

const resetToDefaultState = () => getDefaultState();

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.CREATE_PRODUCT_DETAILS_COMPONENTS]: addComponents,
        [actions.DELETE_PRODUCT_DETAILS_COMPONENTS]: deleteComponents,
        [actions.DECREASE_BUSY_COUNTER]: decreaseBusyCounter,
        [actions.INCREASE_BUSY_COUNTER]: increaseBusyCounter,
        [actions.READ_MEASUREMENT_READINGS_SUCCESS]: updateProductDetails,
        [actions.READ_PRODUCT_DETAILS_CUSTOMER_SUCCESS]: setCustomer,
        [actions.RESET_PRODUCT_DETAILS_COMPONENT_TO_ADD]: resetComponentToAdd,
        [actions.RESET_PRODUCT_DETAILS_OPTION_TO_ADD]: resetOptionToAdd,
        [actions.RESET_PRODUCT_DETAILS_STATE]: resetToDefaultState,
        [actions.TOGGLE_PRODUCT_DETAILS_ACCORDION]: toggleAccordion,
        [actions.TOGGLE_PRODUCT_DETAILS_ACCORDIONS]: toggleAccordions,
        [actions.UPDATE_BASE_MACHINE_IMPLEMENTS_FILE]: updateFile,
        [actions.UPDATE_INCENTIVE_PROGRAMS_SUCCESS]: updateIncentiveDetails,
        [actions.UPDATE_PRODUCT_DETAILS_AMOUNT_OF_USE_MODAL_VISIBILITY]: updateAmountOfUseModalVisibility,
        [actions.UPDATE_PRODUCT_DETAILS_EDIT_AMOUNT_OF_USE_MODAL_VISIBILITY]: updateEditAmountOfUseModalVisibility,
        [actions.UPDATE_OPTION_CODES_SUCCESS]: updateProductDetails,
        [actions.UPDATE_PIPS_SUCCESS]: updateProductDetails,
        [actions.UPDATE_PRODUCT_CLAIMS_SUCCESS]: updateProductDetails,
        [actions.UPDATE_PRODUCT_COMPONENTS_SUCCESS]: updateProductDetails,
        [actions.UPDATE_PRODUCT_IMPLEMENTS_SUCCESS]: updateProductDetails,
        [actions.UPDATE_TEMP_PRODUCT_IMPLEMENTS_PURCHASE_ORDER]: updateTempPurchaseOrder,
        [actions.UPDATE_PRODUCT_DETAILS_CLAIM_TYPES]: updateClaimTypes,
        [actions.UPDATE_PRODUCT_DETAILS_COMPONENTS]: updateBaseMachineComponents,
        [actions.UPDATE_PRODUCT_DETAILS_COMPONENT_CODES]: updateComponentCodes,
        [actions.UPDATE_PRODUCT_DETAILS_COMPONENT_TO_ADD]: updateComponentToAdd,
        [actions.UPDATE_PRODUCT_DETAILS_CREATE_CLAIM_MODAL_VISIBILITY]: updateCreateClaimModalVisibility,
        [actions.UPDATE_PRODUCT_DETAILS_EXTERNAL_NOTES]: updateProductDetails,
        [actions.UPDATE_PRODUCT_DETAILS_OPTION_TO_ADD]: updateOptionToAdd,
        [actions.UPDATE_PRODUCT_DETAILS_PRODUCT_SUCCESS]: updateProductDetails,
        [actions.UPDATE_PRODUCT_DETAILS_PURCHASE_ORDER]: updatePurchaseOrder,
        [actions.UPDATE_PRODUCT_DETAILS_SHOW_ADD_COMPONENT_ROW]: updateShowAddComponentRow,
        [actions.UPDATE_PRODUCT_DETAILS_STATUS_CHANGE_MODAL]: updateProductDetailsStatusChangeModal,
        [actions.UPDATE_PRODUCT_MAINTENANCE_PLANS_SUCCESS]: updateProductDetails,
        [actions.UPDATE_PRODUCT_WARRANTIES_SUCCESS]: updateProductDetails,
        [actions.UPDATE_REGISTRATION_HISTORY_SUCCESS]: updateProductDetails
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/details/reducers/product-details.js